import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    ForecastAvailability,
} from '../serviceCenters.types'

const useGetAvailability = (params: {
    serviceCenter: {id: number},
    includeNotStartedOrders?: boolean,
    includePreBookings?: boolean,
    includeAllDualContainers?: boolean,
}) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<ForecastAvailability>({
        key: RequestKeys.getAvailability,
        params: {
            params,
        },
        requestFunc: RequestFn.getEntity(requestConfig.getAvailability),
        enabled: Boolean(params?.serviceCenter?.id),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetAvailability
